import axios from "axios";
import authManager from "./authManager";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});
instance.interceptors.request.use((config) => {
  config.params = config.params || {};
  return config;
});
// instance.interceptors.request.use(async (config) => {
// config.params = config.params || {};

// const method = config.method?.toLowerCase();
// const needsCsrf = ["post", "put", "patch", "delete"].includes(method || "");

// if (needsCsrf) {
// const res = await instance.get("/api/csrf-token");
// config.headers["X-CSRF-Token"] = res.data.csrfToken;
// }

// return config;
// });
const ApiInterceptor = () => {
  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response?.status === 401) {
        if (error.config) {
          window.location.href = "/";
        }
      }
      return Promise.reject(error);
    }
  );
  return null;
};
ApiInterceptor();
const apiRequest = {
  login: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/corporate-admin/${v}/login`, body),

  sendOtp: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/corporate-admin/${v}/sendOtp`, body),
  resetPassword: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/corporate-admin/${v}/resetPassword`, body),

  verifyOtp: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/corporate-admin/${v}/verifyOtp`, body),

  getDashboardData: ({ v = "v1" } = {}) =>
    instance.get(`/api/corporate-admin/${v}/getDashboardData`, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),
  getProfile: ({ v = "v1" } = {}) =>
    instance.get(`/api/corporate-admin/${v}/profile`, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  getAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/corporate-admin/${v}/getAdmins`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    });
  },

  // corporate admin
  createCorporateAdmin: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/corporate-admin/${v}/head-admin/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  editCorporateAdmin: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/corporate-admin/${v}/head-admin/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  deleteCorporateAdmin: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/corporate-admin/${v}/head-admin/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  updateProfile: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/corporate-admin/${v}/updateProfile`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  getProducts: ({ v = "v1", body } = {}) =>
    instance.post(`/api/corporate-admin/${v}/product/getProducts`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  // vendor
  // vendor

  getVendor: ({ v = "v1", body } = {}) =>
    instance.post(`/api/corporate-admin/${v}/vendor`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  getHeadVendors: ({ v = "v1", body } = {}) =>
    instance.post(`/api/corporate-admin/${v}/vendor/getHeadVendors`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),
  getVendorWithAdmin: ({ v = "v1", body } = {}) =>
    instance.post(`/api/corporate-admin/${v}/vendor/getVendorWithAdmin`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),
  getVendorById: ({ v = "v1", id = "", body } = {}) =>
    instance.post(`/api/corporate-admin/${v}/vendor/getStaffVendors`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),
  createVendor: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/corporate-admin/${v}/vendor/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),
  editVendor: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/corporate-admin/${v}/vendor/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),
  deleteVendor: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/corporate-admin/${v}/vendor/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  getExcelImportList: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/corporate-admin/${v}/excel/imports`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    });
  },

  getCorporateAdminByHeadAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/corporate-admin/${v}/getCorporateAdmins`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    });
  },

  getSuperVendorsByCorporateAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/corporate-admin/${v}/vendor`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    });
  },

  getHeadVendors: ({ v = "v1", body } = {}) =>
    instance.post(`/api/corporate-admin/${v}/vendor/getHeadVendors`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),
  getVendorsBySuperVendor: ({ v = "v1", body } = {}) =>
    instance.post(
      `/api/corporate-admin/${v}/vendor/getVendorsBySuperVendor`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
        },
      }
    ),

  getVendorWithAdmin: ({ v = "v1", body } = {}) =>
    instance.post(`/api/corporate-admin/${v}/vendor/getVendorWithAdmin`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  getGallery: ({ v = "v1", body } = {}) =>
    instance.post(`/api/corporate-admin/${v}/gallery`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  createGallery: ({ v = "v1", formData = {} } = {}) => {
    return instance.post(`/api/corporate-admin/${v}/gallery/create`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    });
  },

  updateGallery: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(`/api/corporate-admin/${v}/gallery/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  deleteGallery: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/corporate-admin/${v}/gallery/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  getVendorCompliance: ({ v = "v1", body } = {}) =>
    instance.post(`/api/corporate-admin/${v}/vendorCompliance`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  createVendorCompliance: ({ v = "v1", formData = {} } = {}) => {
    return instance.post(
      `/api/corporate-admin/${v}/vendorCompliance/create`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
        },
      }
    );
  },

  updateVendorCompliance: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(`/api/corporate-admin/${v}/vendorCompliance/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
      },
    }),

  deleteVendorCompliance: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/corporate-admin/${v}/vendorCompliance/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),
  getVendorManagerForSelect: ({ v = "v1", body } = {}) =>
    instance.post(
      `/api/corporate-admin/${v}/vendor/vendor-manager-list`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getcorporateAdminAccessToken()}`,
        },
      }
    ),
};

export default apiRequest;
